import { jsx as _jsx } from "react/jsx-runtime";
import StatTile from '../common/StatTile';
import { formatDate, formatRelativeDate } from '../../utils/date';
export default function LastRefillTile({ date }) {
    return (_jsx(StatTile, { label: "Last Refill", value: formatDate(date), caption: date ? formatRelativeDate(date) : undefined }));
}
